import OnlineStation from '@src/data/online-station'

export default class UserClubSummary {

  totalStationsCount: number | 0
  onlineStationsCount: number | 0
  inUseStationsCount: number | 0
  freeStationsCount: number | 0
  onlineStations: OnlineStation[] | null

  constructor (attributes = null) {
    if (attributes) Object.assign(this, attributes)
  }
}
